<template>
  <!-- TODO Preklady -->
  <div class="c-bundle-builder">
    <div class="c-bundle-builder__header">
      <h3 class="c-bundle-builder__header__title">Váš zvýhodnený set</h3>

      <button class="c-btn" @click="resetBundleBuilderState">
        <i class="ico ico-close"></i>
        Vymazať set
      </button>

      <button
        @click="closePanel"
        class="c-btn c-btn--primary c-custom-bundle-trigger-close"
      >
        <i class="ico ico-chevron-left"></i>
        Zbaliť
      </button>
    </div>

    <div class="c-bundle-builder__main">
      <div
        v-for="(bundleStep, idx) in bundleSteps"
        :key="bundleStep.id"
        class="c-bundle-builder-step"
        :class="{
          'is-active': idx + 1 === bundleBuilderState.currentStep,
          'is-picked': bundleBuilderState.steps[idx + 1].product,
        }"
      >
        <div class="c-bundle-builder-step__header">
          <div class="c-bundle-builder-step__header__icon">
            <i
              v-if="bundleBuilderState.steps[idx + 1].product"
              class="ico ico-check"
            />
            <span v-else>
              {{ idx + 1 }}
            </span>
          </div>

          <div class="c-bundle-builder-step__header__text">
            <h5 class="c-bundle-builder-step__header__title">
              {{ bundleStep.title }}
            </h5>

            <p
              v-if="
                bundleBuilderState.steps[idx + 1].required &&
                !bundleBuilderState.steps[idx + 1].product
              "
              class="c-bundle-builder-step__header__required-msg"
            >
              povinná položka
            </p>
          </div>
        </div>

        <div
          class="c-bundle-builder-step__product"
          v-if="bundleBuilderState.steps[idx + 1].product"
        >
          <button
            v-if="idx + 1 === lastStepWithProduct"
            class="c-btn c-btn--link c-step-product__remove"
            @click="removeStepProduct(idx + 1)"
          >
            <i class="ico ico-close"></i>
          </button>
          <img
            class="c-step-product__image"
            :src="
              thumbnail(bundleBuilderState.steps[idx + 1].product.image, 'lg')
            "
          />
          <h2 class="c-step-product__name">
            {{ bundleBuilderState.steps[idx + 1].product.name }}
          </h2>

          <div class="c-step-product__prices">
            <span class="c-step-product__price">
              {{
                formatPrice(
                  bundleBuilderState.steps[idx + 1].product.price *
                    bundleBuilderState.steps[idx + 1].product.quantity
                )
              }}
            </span>
            <span class="c-step-product__price--old">
              {{
                formatPrice(bundleBuilderState.steps[idx + 1].product.old_price *
                    bundleBuilderState.steps[idx + 1].product.quantity
                )
              }}
            </span>
            <span class="c-step-product__quantity">
              {{ parseFloat((bundleBuilderState.steps[idx + 1].product.quantity * bundleBuilderState.steps[idx + 1].product.custom_mvm_bal).toFixed(3)) }} <span v-html="bundleBuilderState.steps[idx + 1].product.custom_sell_mj"></span> x
              {{ formatPrice(bundleBuilderState.steps[idx + 1].product.price_m2_vat) }}/<span v-html="bundleBuilderState.steps[idx + 1].product.custom_sell_mj"></span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="c-bundle-builder__footer">
      <div class="c-bundle-builder__totals" v-if="totals">
        <div
          class="c-bundle-builder__totals__price c-bundle-builder__totals__total"
        >
          <p>Spolu</p>

          {{ formatPrice(totals.total) }}
        </div>
        <div
          class="c-bundle-builder__totals__price c-bundle-builder__totals__discount"
        >
          <p>Ušetrili ste</p>

          {{ formatPrice(totals.discount) }}
        </div>
        <div
          class="c-bundle-builder__totals__price c-bundle-builder__totals__final"
        >
          <p>Vaša cena</p>

          {{ formatPrice(totals.final) }}
        </div>
      </div>

      <button
        :disabled="!requiredPicked"
        @click="addBundleToCart()"
        class="c-btn c-btn--cart"
        :class="{ 'is-disabled': !requiredPicked }"
      >
        <i class="ico ico-cart" />
        Vložiť vlastný set do košíka
      </button>
    </div>
  </div>
</template>

<script>
import { formatPrice } from "../utils/format";

import {
  getCookie,
  getBundleBuilderState,
  addBundleToCart,
  resetBundleBuilderState,
  removeProductFromBundle,
} from "../pages/bundleBuilder";

const bundleSteps = [
  { id: 1, required: true, title: "Podlaha" },
  { id: 2, required: true, title: "Podložky" },
  { id: 3, required: true, title: "Soklové lišty" },
  { id: 4, required: false, title: "Profily" },
  { id: 5, required: false, title: "Čistenie a chémia" },
];

export default {
  data: () => {
    return {
      bundleSteps,
      bundleBuilderState: getBundleBuilderState(),
      totals: {},
    };
  },
  mounted() {
    this.getTotals();
  },
  computed: {
    requiredPicked() {
      return (
        Object.values(this.bundleBuilderState.steps).filter(
          (step) => step.required && step.product
        ).length === 3
      );
    },
    lastStepWithProduct() {
      const stepsWithProducts = Object.keys(this.bundleBuilderState.steps)
        .map(Number)
        .filter(stepId => this.bundleBuilderState.steps[stepId].product !== null);
      return stepsWithProducts.length ? Math.max(...stepsWithProducts) : null;
    },
  },
  methods: {
    resetBundleBuilderState,
    addBundleToCart,
    formatPrice,
    thumbnail(imageSrc, format) {
      if (typeof window.Eshop.options.imageSrc === "undefined") {
        console.error("window.Eshop.options.imageSrc is not defined");

        return imageSrc;
      }

      return imageSrc
        ? window.Eshop.options.imageSrc
            .replace("%25s", imageSrc)
            .replace("%s", imageSrc)
            .replace("%format", format)
        : window.Eshop.options.fullUrl + "img/static/noimage.svg";
    },
    closePanel() {
      const bundleEl = document.querySelector(
        ".c-custom-bundle__bundle-builder-wrapper"
      );

      bundleEl.classList.remove("is-active");
    },
    getTotals() {
      this.totals = {
        total: 0,
        discount: 0,
        final: 0,
      };

      const csrfToken = getCookie("csrfToken");
      const headers = new Headers();
      headers.append("X-CSRF-TOKEN", csrfToken);
      headers.append("Accept", "application/json, text/javascript");
      headers.append("x-requested-with", "XMLHttpRequest");
      headers.append("Content-Type", "application/json");

      fetch("/get-bundle-totals", { method: "POST", headers, body: JSON.stringify(this.bundleBuilderState) })
        .then((res) => res.json())
        .then((data) => {
          this.totals = data.totals;

          for (let i = 0; i < data.products.length; i++) {
            if (this.bundleBuilderState.steps[i + 1].product) {
              this.bundleBuilderState.steps[i + 1].product.price = data.products[i].price;
              this.bundleBuilderState.steps[i + 1].product.old_price = data.products[i].old_price;
            }
          }
        })
        .catch((err) => console.log(err));
    },
    removeStepProduct(stepId) {
      removeProductFromBundle(stepId);
      // refresh local state and totals after removal
      this.bundleBuilderState = getBundleBuilderState();
      this.getTotals();
    },
  },
};
</script>
